import { render, staticRenderFns } from "./DetailJournal.vue?vue&type=template&id=c2d31d42&"
import script from "./DetailJournal.vue?vue&type=script&lang=ts&"
export * from "./DetailJournal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2d31d42')) {
      api.createRecord('c2d31d42', component.options)
    } else {
      api.reload('c2d31d42', component.options)
    }
    module.hot.accept("./DetailJournal.vue?vue&type=template&id=c2d31d42&", function () {
      api.rerender('c2d31d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general-journal/DetailJournal.vue"
export default component.exports